import React from 'react';
import { withRouter } from 'react-router-dom';
import LargePaper from '../../components/Layout/LargePaper';
import stylesDefault from '../../constants/stylesDefault';
import AddVouchersForm from '../../components/Voucher/AddVouchersForm';
import withAuthorization from '../../hoc/withAuthorization';

const AddVouchersPage = props =>
  <LargePaper>
    <h1 style={stylesDefault.title}>Créer des coupons</h1>
    <AddVouchersForm history={props.history}/>
  </LargePaper>;

const authCondition = authUser => !!authUser;

export default withAuthorization(authCondition)(withRouter(AddVouchersPage));



// WEBPACK FOOTER //
// ./src/containers/VouchersPage/AddVouchersPage.jsx